export default __webpack_public_path__ + "static/media/music-medium.fcd085da.jpg";